import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class UnitofmeasurementcultureEditService {

	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) { }


	loadUnit(token, ID) {
		

		
		
		
		
		
		
		

		return this.http
		.get(this.apiUrl + "unitofmeasurementculture/v1/getcodunitofmeasurementculture/" + ID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

	editUnit(token, unit: any) {
		

		
		
		
		
		
		
		

		return this.http
		.put(this.apiUrl + "unitofmeasurementculture/v1/updateunitofmeasurementculture", JSON.stringify(unit), JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/unitofmeasurementculture/service/unitofmeasurementculture-edit/unitofmeasurementculture-edit.service.ts